import React, { memo, useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Grid from '@material-ui/core/Grid'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import Chip from '@material-ui/core/Chip'
import EditIcon from '@material-ui/icons/EditOutlined'
import AddIcon from '@material-ui/icons/AddOutlined'
import moment from 'moment'

import styles from './styles'
import { TExperienceProps, IExperienceItem } from 'models'
import { ExperienceModal } from './components'

const useStyles = makeStyles(styles)

const Experience: React.FunctionComponent<TExperienceProps> = ({
	items,
	canEdit,
	updateUser,
}) => {
	const history = useHistory()
	const classes = useStyles()
	const isMobile = useMediaQuery('@media (max-width:680px)')
	const { i18n } = useTranslation()
	const { t } = useTranslation()
	// const [success, setSuccess] = useState(false)
	const [edit, setEdit] = useState(false)
	const [data, setData] = useState<IExperienceItem>()
	const [open, setOpen] = useState(false)

	const goToCompany = React.useCallback(
		(item: IExperienceItem) => {
			history.push(
				`/${i18n.language}/employers/${item.CompanyIdentifier}`,
			)
		},
		[history, i18n.language],
	)

	const isReverseHeader: boolean = i18n.language === 'ro'
	// const toggle = useCallback(() => {
	// 	setEdit(!edit)
	// }, [edit])
	const saveEdit = useCallback(() => {
		setEdit(false)
		// setLoading(true)
	}, [])
	const toggle = useCallback(() => {
		setOpen(open => !open)
	}, [])
	const handleSetData = useCallback(
		(item: IExperienceItem) => () => {
			setData(item)
			toggle()
		},
		[toggle],
	)

	useEffect(() => {
		if (open === false && typeof data !== undefined) setData(undefined)
	}, [open, data])

	return (
		<Grid
			className={classes.section}
			container={true}
			direction="row"
			style={{ position: 'relative' }}
		>
			<Grid item={true}>
				<h2 className={classes.sectionTitle}>
					{isReverseHeader ? t('Experience') : t('My')}{' '}
					<span className={classes.inlineEmphasizedText}>
						{isReverseHeader ? t('My') : t('Experience')}
					</span>
				</h2>
				{canEdit && (
					<Chip
						onClick={toggle}
						style={{ margin: 2, background: '#fff' }}
						icon={<AddIcon />}
						variant="outlined"
						color={'secondary'}
						clickable={true}
						classes={{
							label: classes.editIconLabel,
							root: classes.editRootElement,
						}}
					/>
				)}
			</Grid>
			<Grid container={true} direction="column">
				{items.map((item: IExperienceItem, index: number) => {
					return (
						<Grid
							key={`experience-item-${index}`}
							container={true}
							direction="column"
							className={classes.experienceItem}
						>
							<div className={classes.companyNameOuterContainer}>
								<div
									className={
										classes.companyNameInnerContainer
									}
								>
									{t('At')}{' '}
									<span
										onClick={() =>
											goToCompany(item && item)
										}
									>
										{item && item.company}
									</span>
								</div>
							</div>
							<div
								className={`${
									classes.timeAndPlaceOuterContainerCommon
								} 
										${
											isMobile
												? classes.timeAndPlaceOuterContainerMobile
												: classes.timeAndPlaceOuterContainer
										}`}
							>
								<div
									className={
										classes.timeAndPlaceInnerContainer
									}
								>
									<span>
										{moment(item && item.startDate).format(
											'DD.MM.YYYY',
										)}
									</span>
									-
									<span>
										{item && item.endDate
											? moment(item.endDate).format(
													'DD.MM.YYYY',
											  )
											: 'Present'}
									</span>
									<span
										className={classes.locationInformation}
									>
										{item &&
											item.location &&
											item.location.name}
									</span>
								</div>
							</div>
							<h3
								className={`${classes.jobTitleCommon} ${
									isMobile
										? classes.jobTitleMobile
										: classes.jobTitle
								}`}
							>
								{item && item.title}
							</h3>
							<p className={classes.jobDescription}>
								{item && item.description}
							</p>
							{canEdit && !edit && (
								<>
									{/* {!success && ( */}
									<Chip
										onClick={handleSetData(item)}
										icon={<EditIcon />}
										variant="outlined"
										color={'secondary'}
										clickable={true}
										classes={{
											label: classes.editIconLabel,
											root: classes.editRootElement,
										}}
										style={{ top: 16 }}
									/>
									{/* )} */}
									{/* {success && (
										<div className={classes.saveSuccess}>
											saved!
										</div>
									)} */}
								</>
							)}
							{canEdit && edit && (
								<div
									className={classes.saveEdit}
									onClick={saveEdit}
								>
									save
								</div>
							)}
						</Grid>
					)
				})}
			</Grid>
			{
				<ExperienceModal
					open={open}
					toggle={toggle}
					data={data}
					updateUser={updateUser}
				/>
			}
		</Grid>
	)
}

export default memo(Experience)
